export enum MDMCommandType {
  //Create/Update Finanslovsstruktur
  Paragraf,
  Hovedomraade,
  Aktivitetsomraade,
  Hovedkonto,
  Underkonto,
  Underkontotype,
  Bevillingstype,
  /// <summary>
  /// If user has this commandType, user can update Variablebevilling And Viderefoerselsadgange in Hovedkonto
  /// </summary>
  ForwardAccessandVariableGrant,

  //Afstlut Finanslovsstruktur
  AfstlutParagraf,
  AfstlutHovedomraade,
  AfstlutAktivitetsomraade,
  AfstlutHovedkonto,
  AfstlutUnderkonto,
  AfstlutUnderkontotype,

  //Kontostruktur
  Standardkonto,
  Regnskabskonto,
  Statuspost,
  Hovedart,

  //Regnskabsstruktur
  Ministeransvarsomraade,
  Virksomhed,
  RegnskabsfoerendeInstitution,
  Bogfoeringskreds,
  /// <summary>
  /// User Story 13845: STR felt til bogføringskreds
  /// If user has this commandType, user can update field RegnskabsposteringerPaakrævetTilStatsregnskab in Bogfoeringskreds
  /// </summary>
  BogfoeringskredsRegnskabsposteringerPaakrævetTilStatsregnskab,
  Delregnskab,
  CloseDelregnskabWithoutValidation,
  ReopenDelregnskabBySameYearValidation,
  EANNummer,
  Aktivitet,

  //Move or reopen Regnskabsstruktur
  MoveRegnskabsstruktur,
  ReopenDelregnskab,

  //Update underkoto-delregnskab relationship
  UpdateUnderkontoDelregnskab,

  //Process & process-right

  /// <summary>
  /// MDM Systemadministrator, MDMProcesstyring and SADAProcesstyring can access for now
  /// </summary>
  Processstyring,

  /// <summary>
  /// MDM Systemadministrator, MDMProcesrettighedssstyring and MDMParagrafRedaktør can access for now
  /// </summary>
  Procesrettigheder,

  /// <summary>
  /// MDM Systemadministrator and MDMEksternProcesrettighedssstyring can access for now
  /// </summary>
  ProcesrettighederEkstern,

  /// <summary>
  /// If user has this commandType, user can update Aaben field in Process-Right
  /// </summary>
  UpdateAaben,

  /// <summary>
  /// If user has this commandType, user can update Niveau1 field in Process-Right
  /// </summary>
  UpdateNiveau1,

  /// <summary>
  /// If user has this commandType, user can update Niveau2 field in Process-Right
  /// </summary>
  UpdateNiveau2,

  /// <summary>
  /// If user has this commandType, user can update Niveau3 field in Process-Right
  /// </summary>
  UpdateNiveau3,

  /// <summary>
  /// Lock or unlock process right to prevent or alow other users from edit process - right.
  /// only user with MDMProcesrettighederLasRole can update Process-Right-Editing-Status
  /// </summary>
  UpdateProcessRightPermissionStatus,

  //RequiredAdmin
  RequiredAdmin,

  //Create/update period
  CreateUpdatePeriodElement,

  EditAfterKonteringSlut,
  CloseEANNumber,

  ReadLoengrupperAndFaellesskaber,
  WriteLoengrupperAndFaellesskaber,
}
